import {NoticeData} from '../type';

export function getNoticePage(
  noticeData: NoticeData,
  currentNoticeId?: string
) {
  if (currentNoticeId === undefined) {
    return 0;
  }
  const noticeIndex = noticeData.items.findIndex(
    notice => notice.id === currentNoticeId
  );
  return Math.floor(noticeIndex / NOTICE_NUM_PER_PAGE) + 1;
}

const NOTICE_NUM_PER_PAGE = 10;
